import { render, staticRenderFns } from "./virementDetails.vue?vue&type=template&id=27d5e1f4&"
import script from "./virementDetails.vue?vue&type=script&lang=js&"
export * from "./virementDetails.vue?vue&type=script&lang=js&"
import style0 from "./virementDetails.vue?vue&type=style&index=0&id=27d5e1f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports